export default {
  PUSH_NOTIFICATION_REGISTRATION: "pushNotification/REGISTRATION",
  PUSH_NOTIFICATION_REGISTRATION_SUCCESS:
    "pushNotification/REGISTRATION-SUCCESS",
  PUSH_NOTIFICATION_ERROR: "pushNotification/ERROR"
};
